import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/auth/api/auth.service';
import { ServerErrorsService } from '@app/shared/services/server-errors.service';
import { SpinnerService } from '@app/shared/services/spinner.service';
import { ToastService } from '@app/shared/services/toast.service';
import { Result } from '@app/shared/util/types/result';
import { AuthUrlBuilder } from '../auth-url-builder';

@Injectable()
export class PasswordDefinitionService {
  public firstPasswordTask: Result;

  constructor(
    private router: Router,
    private spinnerService: SpinnerService,
    private authService: AuthService,
    private toastService: ToastService,
    private serverErrorService: ServerErrorsService
  ) {}

  async submit(newPassword1: string, uid: string, token: string) {
    const spinner = await this.spinnerService.showSpinner();
    this.firstPasswordTask = await this.authService.changePassword(newPassword1, uid, token);

    if (this.firstPasswordTask.isSuccess) {
      await this.toastService.success('Senha definida com sucesso.');
      await this.router.navigate([AuthUrlBuilder.login()], { replaceUrl: true });
    } else {
      await this.serverErrorService.showErrors(
        this.firstPasswordTask.error,
        'Não foi possível definir a senha, tente novamente.'
      );
    }

    await spinner.dismiss();
  }
}
